import { useSelector } from 'react-redux'
import { useQuery } from '@tanstack/react-query'
import { useNavigate, useOutletContext } from 'react-router-dom'

import MissionSetupTabs from '@App/components/MissionSetupTabs/MissionSetupTabs'
import ActionBtn from '@App/components/ActionBtn/ActionBtn'
import DataSectionTitle from '@App/components/DataSectionTitle/DataSectionTitle'
import SourceToggles from '@App/components/SourceToggles/SourceToggles'
import TypeToggles from '@App/components/TypeToggles/TypeToggles'
import { fetchMissionDataSourcesByGroup, fetchMissionDataTypesByGroup } from '@services/data.service'

import { setSourceActiveNames, setBreedingSiteActiveTypeIds } from '../mission-setup.slice'

import BreedingSitesData from './BreedingSitesData/BreedingSitesData'

import './breeding-sites.styl'

function BreedingSites() {
  const navigate = useNavigate()
  const { map } = useOutletContext()

  const { activeProject, sourcesActiveNames } = useSelector(state => state.missionSetup)
  const { breedingSiteActiveTypeIds } = useSelector(state => state.missionSetup)

  const { data: sources } = useQuery({
    queryKey: ['sources', activeProject?.id, 'breeding'],
    queryFn: () => fetchMissionDataSourcesByGroup(activeProject?.id, 'breeding'),
  })

  const { data: types } = useQuery({
    queryKey: ['types', 'breeding', activeProject?.id],
    queryFn: () => fetchMissionDataTypesByGroup('breeding', activeProject?.id),
  })

  return (
    <div className="breeding-sites">
      <MissionSetupTabs />
      <hr />
      <div className="environment__action">
        <ActionBtn
          onClick={() => navigate('/mission-setup/breeding-sites/add')}
        >
          Add permanent breeding site
        </ActionBtn>
      </div>
      <hr />
      {sources && sources.length > 0
        ? (
            <>
              <DataSectionTitle>Types</DataSectionTitle>
              <TypeToggles
                types={types}
                activeTypeIds={breedingSiteActiveTypeIds}
                setActiveTypeIds={setBreedingSiteActiveTypeIds}
                badgeShape="triangle"
              />
              <DataSectionTitle>Data source</DataSectionTitle>
              <SourceToggles
                sources={sources}
                sourcesActiveNames={sourcesActiveNames}
                setSourceActiveNames={setSourceActiveNames}
              />
              <BreedingSitesData />
            </>
          )
        : (
            <p className="breeding-sites__no-data">
              No breeding site data for this mission.
            </p>
          )}
    </div>
  )
}

export default BreedingSites
